import { Articulo } from '@/__env/lib/Articulos';
import { ControladorNuevoPedido, Item } from '@/views/a-pedido-cargar/controlador-pedido';
import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from 'strongly-typed-events';
import { Random } from '@/__env/ext';
import { isString, isNumber } from 'util';
import { Mensaje } from '@/__env/lib/Chats';
import { Utiles } from '@/__env/pluggins/event-bus';
import { resolveAny } from 'dns';
import { OpcionDePrecio } from '@/__env/lib/Articulos/Articulo.lib';
import { Item as ItemPedido } from '@lib/Ventas/Pedidos/Item';
import _ from 'lodash';

export class ControladorNuevoItem
{

    constructor( controlador: ControladorNuevoPedido )
    {
        this.Controlador = controlador;

    }
    protected Controlador: ControladorNuevoPedido;
    protected articulo: Articulo = new Articulo();
    public get Articulo(): Articulo { return this.articulo; }

    protected cantidad: number = 0;
    public get Cantidad(): number { return this.cantidad; }

    //protected set Articulo( x: Articulo ) { this.articulo = x; }


    async AgregarArticulo( codigo: string | Articulo ): Promise<{ Resultado: boolean, Mensaje: string; }>
    {
        this.articulo = null;
        let resultado = true;
        let mensaje = '';
        if ( isString( codigo ) )
        {
            let ff: any = {};
            ff.details = 'precio';
            ff.opciones_precio = {
                tipo: this.Controlador.Tipo.Lista,
                cliente: this.Controlador.Cliente.Id
            };
            this.articulo = await Articulo.create( codigo, ff );

        } else if ( codigo && codigo instanceof Articulo && codigo.Existe )
        {
            this.articulo = codigo;
        }

        if ( !this.articulo || !this.articulo.Existe )
        {
            resultado = false;
            mensaje = '¡Artículo no existe!';
        } else if ( !this.articulo.Precio || !this.articulo.Precio.Existe )
        {
            resultado = false;
            mensaje = `El artículo ${this.articulo.Id} no está disponible en este tipo de pedido`;
        }

        return {
            Resultado: resultado,
            Mensaje: mensaje
        };
    }

    async Agregar( articulo?: Articulo | string, cantidad?: number, index?: number, itemPedido?: ItemPedido ): Promise<{ Resultado: boolean, Item: Item, Index: number, Mensaje: string; }>
    {
        if ( !this.Controlador.Iniciado )
        {

            Utiles.Notificaciones.Error( '¡No hay un pedido seleccionado!' );
            return {
                Resultado: false,
                Index: -1,
                Item: null,
                Mensaje: '¡No hay un pedido seleccionado!'
            };
        }

        let resultado = false;
        let NoModificable = false;
        let mensaje = '';


        if ( isNumber( index ) )
        {

            if ( !this.Controlador.Items[index] )
            {
                return { Resultado: false, Item: this.Controlador.Items[index], Index: index, Mensaje: '' };

            }
            else if ( this.Controlador.Items[index].NoModificable )
            {
                return { Resultado: false, Item: this.Controlador.Items[index], Index: index, Mensaje: 'Imposible. El item no se puede modificar' };
            }

            this.articulo = this.Controlador.Items[index].Articulo;
            this.cantidad = this.Controlador.Items[index].Cantidad;
            if ( isNumber( cantidad ) && this.ControlFraccion( cantidad, this.Articulo ) )
            {
                this.cantidad = cantidad;
                if ( this.Articulo.Precio && this.Articulo.Precio.Existe )
                {
                    await this.Articulo.cargarPrecio( this.Articulo.Precio.Tipo, this.cantidad, this.Controlador.Cliente.Id, this.Articulo.Precio.SubTipo, this.Articulo.Precio.IdPublicacion );
                } else
                {
                    await this.Articulo.cargarPrecio( this.Controlador.Tipo.Lista, this.cantidad, this.Controlador.Cliente.Id );
                }
            } else
            {
                return { Resultado: false, Item: this.Controlador.Items[index], Index: index, Mensaje: 'La fracción es incorrecta' };
            }

        } else if ( itemPedido && itemPedido instanceof ItemPedido )
        {
            this.articulo = itemPedido.Articulo;
            this.articulo.Precio = _.cloneDeep( itemPedido.PrecioFijado );
            this.cantidad = itemPedido.Cantidad;
            this.articulo.Precio.IdPublicacion = itemPedido.IdExterna;
            if ( this.Controlador.Tipo.esMercadoLibre )
                NoModificable = true;
            index = -1;

        } else
        {
            this.cantidad = isNumber( cantidad ) ? cantidad : 1;
            if ( isString( articulo ) )
            {
                articulo = await Articulo.create( articulo, {
                    details: 'precio',
                    opciones_precio: {
                        tipo: this.Controlador.Tipo.Lista,
                        cantidad: this.cantidad,
                        cliente: this.Controlador.Cliente.Id
                    }
                } );

                if ( articulo )
                    this.cantidad = articulo.CantidadFraccion;
            }

            this.articulo = articulo;
            if ( this.articulo )
            {
                if ( this.Articulo.Precio && this.Articulo.Precio.Existe )
                {

                    await this.Articulo.cargarPrecio( this.Articulo.Precio.Tipo, this.cantidad, this.Controlador.Cliente.Id, this.Articulo.Precio.SubTipo, this.Articulo.Precio.IdPublicacion );
                } else
                {
                    await this.Articulo.cargarPrecio( this.Controlador.Tipo.Lista, this.cantidad, this.Controlador.Cliente.Id );
                }
            }

            index = -1;
        }


        if ( !this.articulo || !this.articulo.Existe )
        {
            resultado = false;
            mensaje = '¡Artículo no existe!';
        } else if ( !this.articulo.Precio || !this.articulo.Precio.Existe )
        {
            resultado = false;
            mensaje = `El artículo ${this.articulo.Id} no está disponible en este tipo de pedido`;
        } else
        {
            let item = new Item();
            item.Articulo = this.Articulo;
            item.Cantidad = this.Cantidad;
            item.Importes.Neto = this.Articulo.Precio.Importes.Neto;
            item.Importes.Final = this.Articulo.Precio.Importes.Final;
            item.Importes.Iva = this.Articulo.Precio.Importes.Iva;
            item.NoModificable = NoModificable;
            console.log( item.Cantidad );
            if ( item.Cantidad > 0 )
            {
                index = this.EditarItems( item );
                resultado = index >= 0;
            } else
            {
                index = this.EliminarItem( item );
                resultado = index >= 0;
            }

        }


        return {
            Resultado: resultado,
            Index: index,
            Item: this.Controlador.Items[index] ? this.Controlador.Items[index] : null,
            Mensaje: mensaje
        };
    }


    async Eliminar( index: number | Item ): Promise<{ Resultado: boolean, Item: Item, Index: number, Mensaje: string; }>
    {
        if ( index instanceof Item )
        {
            return await this.Agregar( index.Articulo, 0 );
        } else
        {
            return await this.Agregar( this.Controlador.Items[index].Articulo, 0 );
        }
    }

    async SiguientePrecio( row: number | Item, reversa?: boolean ): Promise<{ Resultado: boolean, Item: Item, Index: number, Mensaje: string; }>
    {
        let articulo: Articulo;
        let cantidad: number;
        let ultimo: number;

        if ( isNumber( row ) )
        {
            articulo = this.Controlador.Items[row].Articulo;
            cantidad = this.Controlador.Items[row].Cantidad;
            ultimo = this.Controlador.Items[row].Ultimo;
            if ( this.Controlador.Items[row].NoModificable )
            {
                return { Resultado: false, Item: null, Index: -1, Mensaje: 'Imposible. El item no se puede modificar' };
            }
            else if ( this.Controlador.Cliente.esMayorista )
            {
                return { Resultado: false, Item: null, Index: -1, Mensaje: 'Imposible. El precio no se puede modificar' };
            }

        } else
        {
            articulo = row.Articulo;
            cantidad = row.Cantidad;
            ultimo = row.Ultimo;
            if ( row.NoModificable )
            {
                return { Resultado: false, Item: null, Index: -1, Mensaje: 'Imposible. El item no se puede modificar' };
            }
            else if ( this.Controlador.Cliente.esMayorista )
            {
                return { Resultado: false, Item: null, Index: -1, Mensaje: 'Imposible. El precio no se puede modificar' };
            }

        }




        let e = await articulo.cargarPrecios( this.Controlador.Tipo.Lista, null, this.Controlador.Cliente.Id );
        if ( !e.Error )
        {


            if ( reversa )
            {
                if ( ultimo == 0 )
                    ultimo = e.Items.length;

                for ( var i = e.Items.length - 1; i >= 0; i-- )
                {
                    let item = e.Items[i];
                    if ( ultimo >= i && articulo.Precio.SubTipo != item.SubTipo )
                    {
                        if ( await articulo.cargarPrecio( item.Tipo, cantidad, this.Controlador.Cliente.Id, item.SubTipo, item.Id ) )
                        {
                            let a = await this.Agregar( articulo, cantidad );
                            if ( a.Resultado )
                            {
                                a.Item.Ultimo = i;
                                return a;
                            }
                        }
                    }
                }

            } else
            {
                if ( ultimo + 1 >= e.Items.length )
                    ultimo = -1;

                for ( var i = 0; i < e.Items.length; i++ )
                {
                    let item = e.Items[i];
                    if ( ultimo < i && articulo.Precio.SubTipo != item.SubTipo )
                    {
                        if ( await articulo.cargarPrecio( item.Tipo, cantidad, this.Controlador.Cliente.Id, item.SubTipo, item.Id ) )
                        {
                            let a = await this.Agregar( articulo, cantidad );
                            if ( a.Resultado )
                            {
                                a.Item.Ultimo = i;
                                return a;
                            }
                        }
                    }
                }
            }
        }

        return {
            Resultado: false,
            Index: -1,
            Item: null,
            Mensaje: 'No hay opciones de precio para este producto'
        };

    }

    protected EditarItems( e: Item ): number
    {
        let idx = this.Controlador.Items.findIndex( a => a.Articulo.Id == e.Articulo.Id );
        if ( idx == -1 )
        {
            this.Controlador.Items.push( e );
            this._onAgregarItem.dispatch( e, this.Controlador.Items.length - 1 );
            this._onActualizar.dispatch();
            return this.Controlador.Items.length - 1;
        } else
        {
            if ( this.Controlador.Items[idx].NoModificable )
            {
                Utiles.Notificaciones.Alerta( 'Imposible. El item no se puede modificar' );
                return idx;
            }

            this.Controlador.Items.splice( idx, 1, e );
            this._onEditarItem.dispatch( e, idx );
            this._onActualizar.dispatch();
            return idx;
        }
    }
    protected EliminarItem( e: Item )
    {
        let idx = this.Controlador.Items.findIndex( a => a.Articulo.Id == e.Articulo.Id );
        if ( idx != -1 )
        {
            if ( this.Controlador.Items[idx].NoModificable )
            {
                Utiles.Notificaciones.Alerta( 'Imposible. El item no se puede modificar' );
                return idx;
            }

            this.Controlador.Items.splice( idx, 1 );
            this._onEliminarItem.dispatch( e, idx );
            this._onActualizar.dispatch();
            return idx;
        }
    }


    private _onActualizar = new SignalDispatcher();
    public get onActualizar() { return this._onActualizar.asEvent(); }

    private _onEliminarItem = new EventDispatcher<Item, number>();
    public get onEliminarItem() { return this._onEliminarItem.asEvent(); }
    private _onAgregarItem = new EventDispatcher<Item, number>();
    public get onAgregarItem() { return this._onAgregarItem.asEvent(); }
    private _onEditarItem = new EventDispatcher<Item, number>();
    public get onEditarItem() { return this._onEditarItem.asEvent(); }

    public ControlFraccion( cantidad: number, a: Articulo ): boolean
    {
        if ( this.Controlador.Tipo.esNormal )
            return cantidad % a.CantidadFraccion == 0;
        else
            return ( parseInt( a.UnidadId ) != 5 ? cantidad % 1 == 0 : true );
    }
}
